import { TableHeader } from "@/models/TableHeader";

export const userHeaders: TableHeader[] = [
  {
    text: "User ID",
    value: "id",
    width: "7rem"
  },
  {
    text: "Username",
    value: "username",
    width: "20rem"
  },
  {
    text: "Name",
    value: "last_name",
    width: "30rem"
  },
  {
    text: "Email Address",
    value: "email",
    width: "30rem"
  },
  {
    text: "Actions...",
    sortable: false
  }
];
